import { render, staticRenderFns } from "./insuranceprofile.vue?vue&type=template&id=21f94ee8"
import script from "./insuranceprofile.vue?vue&type=script&lang=js"
export * from "./insuranceprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports